import { lazyLoad } from 'utils/loadable';

export const ContactFormPage = lazyLoad(
  () => import('./index'),
  module => module.ContactFormPage,
);
